import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { useFormikGoodFilters } from '../../../../utils';
import { GoodsFilter } from '../../types';
import { useEntryStates, useSupervisors } from '../../../../share';
import GoodsCreateContainer from './GoodsCreateContainer';
import GoodsDetailContainer from './GoodsDetailContainer';
import { useCancelRequest, useFetchGoodsRequests } from '../../../../hooks';
import GoodsView from '../Views/GoodsView';
import { useAtom } from 'jotai';
import { authAtom } from '../../../../state';
import { useCustomToast } from '../../../../components';

const handlePagination = (
  page: number,
  setFilter: React.Dispatch<React.SetStateAction<GoodsFilter>>
) => {
  setFilter({
    page: page.toString(),
  });
};

const GoodsContainer: React.FC = () => {
  const { data: entryStates } = useEntryStates();
  const { data: supervisors } = useSupervisors();

  const [modalCreate, setmodalCreate] = useState(false);
  const [modalDetail, setmodalDetail] = useState(false);

  const { mutateAsync: cancelRequest } = useCancelRequest();

  const [authData] = useAtom(authAtom);
  const [filter, setFilter] = React.useState<GoodsFilter>(() => {
    if (!authData?.user?.id) return {};
    return { requester_id: authData.user.id };
  });

  const {
    data: goods,
    isPending: loadList,
    refetch,
  } = useFetchGoodsRequests(filter || {});
  const [itemSelected, setItemSelected] = useState<any>();

  const { showToast } = useCustomToast();

  const formik = useFormikGoodFilters({
    onSubmit: (values) => handleFilter(values, authData, setFilter),
  });

  const handleFilter = useCallback(
    async (
      values: Partial<GoodsFilter>,
      authData: any,
      setFilter: React.Dispatch<React.SetStateAction<GoodsFilter>>,
    ) => {
      setFilter({
        ...values,
        requester_id: values.requester_id ? values.requester_id : authData.user.id,
        created_at: values.created_at
          ? new Date(values.created_at).toISOString().split('T')[0]
          : '',
      });
    },
    []
  );

  const onCancelRequest = async (
    id: string,
    observations: string,
  ) => {
    try {
      await cancelRequest({ id, data: { reason: observations } });
      handleFilter({}, authData, setFilter);
    } catch (error) {
      showToast('error', 'Error al anular solicitud.');
    }
  };

  useEffect(() => {
    refetch();
  }, [filter, refetch]);


  return (
    <Fragment>
      {!loadList && (
        <GoodsCreateContainer
          isOpen={modalCreate}
          OnClose={() => {setmodalCreate(false)}}
        />
      )}
      {modalDetail && (
        <GoodsDetailContainer
          isOpen={modalDetail}
          OnClose={() => {
            setmodalDetail(false);
            formik.resetForm();
          }}
          data={itemSelected}
          refetch={refetch}
          isApproveRequest={false}
        />
      )}
      <GoodsView
        isLoading={loadList}
        data={goods}
        supervisors={supervisors}
        states={entryStates}
        formik={formik}
        onViewCreate={() => {setmodalCreate(true)}}
        onViewDetail={(item: any) => {
          setmodalDetail(true);
          setItemSelected(item);
        }}
        onPagination={(page) => handlePagination(page, setFilter)}
        onResetFilters={() => {
          handleFilter({}, authData, setFilter);
          formik.resetForm();
        }}
        onCancelRequest={(id, observations) => onCancelRequest(id, observations)}
      />
    </Fragment>
  );
};

export default GoodsContainer;